import { useUtilityContext } from '@change-corgi/core/react/utilityContext';
import type { PaymentMethodUsage } from '@change-corgi/middle-end-gql-schema';

import type { PaymentType } from 'src/app/shared/utils/payments';
import { saveStripePaymentMethod } from 'src/app/shared/utils/payments';

import { useSetupAndConfirm } from './useSetupAndConfirm';

type Params = {
	paymentType: PaymentType;
	token?: string;
	accountId?: string;
	tokenType?: 'temporary' | 'permanent';
	usage: PaymentMethodUsage;
	email: string;
	countryCode: string;
	currencyCode: string;
	locale?: string;
	skipTempCustomer?: boolean;
};

// eslint-disable-next-line max-lines-per-function
export function useStripePermanentPaymentMethod(): (params: Params) => Promise<void> {
	const utilityContext = useUtilityContext();
	const setupAndConfirmPaymentMethod = useSetupAndConfirm();

	return async (params): Promise<void> => {
		const {
			token,
			usage,
			email,
			paymentType,
			tokenType,
			countryCode,
			currencyCode,
			accountId,
			locale,
			skipTempCustomer,
		} = params;
		const paymentMethod = { id: token };

		// When skipTempCustomer is true, save payment method before setup intent
		if (skipTempCustomer && tokenType === 'temporary' && paymentMethod.id) {
			await saveStripePaymentMethod({
				token: paymentMethod.id,
				email,
				usage,
				utilityContext,
				paymentType,
				accountId,
				locale,
				countryCode,
			});
		}

		await setupAndConfirmPaymentMethod({
			paymentMethod,
			usage,
			paymentType,
			countryCode,
			currencyCode,
			accountId,
			skipTempCustomer,
		});

		// When skipTempCustomer is false, save payment method after setup intent (original flow)
		if (!skipTempCustomer && tokenType === 'temporary' && paymentMethod.id) {
			await saveStripePaymentMethod({
				token: paymentMethod.id,
				email,
				usage,
				utilityContext,
				paymentType,
				accountId,
				locale,
				countryCode,
			});
		}
	};
}
